import { Swiper, SwiperSlide } from "swiper/react";
import ReviewsData from "../Data/ReviewsData";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Pagination } from "swiper/modules";

const Reviews = () => {
  return (
    <div className="reviews-slider">
      <Swiper
        slidesPerView={"auto"}
        centeredSlides={true}
        navigation={true}
        spaceBetween={20}
        pagination={{
          clickable: true,
        }}
        draggable={true}
        modules={[Navigation, Pagination]}
        loop={true}
        className="mySwiper"
      >
        {ReviewsData?.map((item, ind) => {
          return (
            <SwiperSlide key={ind}>
              <div className="cursor-grab w-full sm:w-[370px] py-[20px] sm:py-[40px] h-full bg-[#fafafa] flex flex-col justify-center items-center gap-3 px-5 sm:px-9 box-border">
                <div className="flex flex-col items-center gap-2 mt-2">
                  <h3 className="text-center text-[20px] sm:text-[24px] leading-[28px] sm:leading-[34px]"> {item?.comment} </h3>
                  <p className="text-[#09001c80] text-[15px] inter-medium">
                    {item?.name}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
export default Reviews;
